// extracted by mini-css-extract-plugin
var _1 = "Z9GEf";
export { _1 as "base" }
